import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import partsImg from '../../../images/parts-pic.jpg';
import Drawer from '../../../components/Drawer';
import CreateCyclecount from './_components/createCyclecount';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import { useCycleCountApi } from '../../../store/api/hooks/cycleCountApiHook';
import { DATE_FORMAT, PAGE_SIZE } from '../../../_common/constant';
import { filterConfigType } from '../../../_config/types';
import Loader from '../../../components/loader';
import { titleCell } from '../../../components/elements/function';
import moment from 'moment';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Filters from '../../../components/filters';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { downloadExcel, downloadPDF } from '../../../_common/functions';
import { useFacilityManagersSelector } from '../../../store/selectors/masterSelector';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';


const CycleCount: React.FC = () => {
    const commonApi: any = useCommonApi();
    const cycleCountAPI = useCycleCountApi();
    const { confirm } = useDialog();
    const facilityApi: any = useFacilitiesApi();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [editData, setEditData] = useState<any>(null);

    const addNewCycleCountRef: any = useRef();

    const users = useFacilityManagersSelector();

    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const filterConfig: filterConfigType[] = [
        { name: 'Code', type: 'text', key: 'inventoryCycleCountCode' },
        { name: 'Operator', type: 'dropdown', key: 'operatorIDs', options: users ? users : [] },
    ]

    const [facilityoption, setFacilityoption] = useState<any>([]);

    const [rowData, setRowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);

    useEffect(() => {
            if (users == null) {
                commonApi.GetUserList({
                    pageNo: 1,
                    pageSize: 1000
                }, (resp: any) => { }, (error: any) => { })
            }
        }, [users])

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "view":
                // Implement edit action
                setEditData(rowData);
                //addNewAssetRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "downloadPdf":
                ExportPdf({ inventoryCycleCountID: rowData.inventoryCycleCountID });
                break;
            case "downloadXlsx":
                ExportXls({ inventoryCycleCountID: rowData.inventoryCycleCountID });
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Asset',
                    message: 'Are you sure you want to delete this asset?',
                    onConfirm: () => {
                        cycleCountAPI.Delete({ id: rowData.assetID }, (data: any, msg: any) => {
                            toast.success(msg);
                            getCycleCounts();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;


            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Cycle Count Ref No', field: 'inventoryCycleCountCode', headerClass: 'bg-[#f0f0f0]', width: 180 },
        { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
        { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
        {
            headerName: 'Created Date and Time', field: 'addedDate', headerClass: 'bg-[#f0f0f0]', width: 200,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{data.value ? moment(data.value).format(DATE_FORMAT) : '-'}</p>
                )
            }
        },
        { headerName: 'Counted by', field: 'operatorName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        {
            headerName: 'Completed Date and Time', field: 'countingDate', headerClass: 'bg-[#f0f0f0]', width: 200,
            cellRenderer: (data: any) => data.data.isDraft ? titleCell({ value: data.value ? moment(data.value).format(DATE_FORMAT) : '-' }) : '-'
        },
        {
            headerName: 'Completed by', field: 'operatorName', headerClass: 'bg-[#f0f0f0]', width: 160,
            cellRenderer: (data: any) => data.data.isDraft ? titleCell(data) : '-'
        },
        {
            headerName: 'Status', field: 'isDraft', headerClass: 'bg-[#f0f0f0]', width: 120, cellStyle: {
                alignItems: 'center'
            }, cellRenderer: (data: any) => data.value ? 'Proccesed' : 'Pending'
        },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,

            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            {/* <option value="view">View</option> */}
                            <option value="downloadXlsx">Download Xlsx</option>
                            <option value="downloadPdf">Download Pdf</option>
                        </select>
                    </div>
                );
            },

        }
    ]

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facility: any) => {
                    facilitylist.push({
                        label: facility.facilityName,
                        value: facility.facilityID,
                        data: facility
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    // Define row data
    /* const rowData: any[] = [
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },
        { 'ref-no': 'RC 001', 'facility': 'Poultry Zone 01', 'sub-facility': 'AF Farm 01', 'created-date': '5/30/24', 'counted-by': 'John Doe', 'completed-date': '15/30/24', 'completed-by': 'John Doe', 'status': 'Processed', 'action': '' },


    ]; */

    const getCycleCounts = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        cycleCountAPI.GetList(payload, (resp: any) => {
            console.log('Cycle Count List', resp);
            setRowData(resp.cycleCountList ? resp.cycleCountList : []);
            setTotalRecords(resp.totalRecord);
        }, (error: any) => {
            setRowData([]);
            setTotalRecords(0);
        });
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const IDs = selectedData.map((rowData: any) => rowData.inventoryCycleCountID).join(',');
            ExportPdf({ inventoryCycleCountID: IDs });
        }
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const IDs = selectedData.map((rowData: any) => rowData.inventoryCycleCountID).join(',');
            ExportXls({ inventoryCycleCountID: IDs });
        }
    };

    const ExportPdf = (payload:any) => {
        cycleCountAPI.ExportToPdf(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'CycleCount')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    const ExportXls = (payload:any) => {
        cycleCountAPI.ExportToXls(
            payload,
            (resp: any) => { downloadExcel(resp, 'CycleCount') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        if (rowData) {
            getCycleCounts();
        }
    }, [currentPage, searchParam, filters]);

    useEffect(() => {
        getfacilitylist();
        getCycleCounts();
    }, []);



    return (
        <Layout>
            <Header title='Cycle Count'>
                <Header.Right>
                    <Drawer _ref={addNewCycleCountRef} onClose={() => {
                        setEditData(null);
                        addNewCycleCountRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Add New'} Cycle Count</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Cycle Count' : 'Create New Cycle Count'} className='!w-[39.563rem]'>
                            <CreateCyclecount _ref={addNewCycleCountRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                getCycleCounts();
                                addNewCycleCountRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewCycleCountRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div>
                <div className='flex items-center justify-between px-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                    />
                    <Search onSearch={setSearchParam} />
                </div>
                <div className='bg-[#FAFAFA]'>
                    <div className='flex gap-4 px-5 py-2 items-center'>
                        <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} /></Button>
                        <Dropdown>
                            <Dropdown.Button>
                                <Button theme='light'><Icon name='grlocation' size={1.20} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                            </Dropdown.Button>
                            <Dropdown.Content >
                                {facilityoption?.map((facility: any) => {
                                    return (
                                        <Menu onClick={() => {
                                            console.log('facility', facility);
                                            setFilters({ ...filters, facilityIDs: [facility.value] })
                                        }}>{facility.label}</Menu>
                                    )
                                }
                                )}
                            </Dropdown.Content>
                        </Dropdown>
                        <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { setFilters({}) }} >Clear Filters</p>
                    </div>
                    <div className="ag-theme-alpine mx-4  h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData} // Pass rowData
                            pagination={false}
                            rowSelection="multiple"
                            onGridReady={onGridReady}
                            domLayout="autoHeight"
                            onRowClicked={onRowClicked}
                            loadingOverlayComponent={Loader}
                        />
                    </div>
                </div>
                {/* Add your component code here */}
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default CycleCount;